import './About.css'
import AboutContent from './AboutContent'
import Services from '../../Components/Services/Services'
import Counselor from '../../Components/Counselor/Counselor'
export default function About() {
    return (
        <>
            <AboutContent></AboutContent>
            <Counselor></Counselor>
            <Services></Services>
        </>
    )
}
